class DrawerYouMayAlsoLike extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
        this.scrollBar = this.querySelector('.swiper-scrollbar');
        this.productsContainer = this.querySelector('.drawer-you-may-also-like__products');
    }

    connectedCallback() {
        if (this.swiperContainer && !this.swiper) {
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 1.2,
                spaceBetween: 9,
                scrollbar: {
                    el: this.scrollBar || null,
                    draggable: true,
                },
                breakpoints: {
                    320: {
                        spaceBetween: 9,
                        slidesPerView: 1.1,
                    },
                    750: {
                        spaceBetween: 9,
                        slidesPerView: 1.2,
                    }
                },
                watchSlidesProgress: true,
                on: {
                    progress: (swiper, progress) => {
                        if (progress >= 1) {
                            this.productsContainer.classList.add('swiper-end');
                        } else {
                            this.productsContainer.classList.remove('swiper-end');
                        }
                    },
                }
            })
        }
    }
}
customElements.define('drawer-you-may-also-like', DrawerYouMayAlsoLike);
